module.exports = __webpack_public_path__ + "2951a22b5b150a1daa949a82361611bf.svg";